export const CUSTOM_TENANT_ROLE_KEY_PREFIX = 'tenant-';

export type GroupOptionLike = {
	key?: string | number;
	data?: {
		id?: number;
		rootGroupId?: number | null;
		isTenant?: boolean;
		level?: number;
		parentId?: number | null;
	};
};

export type CustomTenantRoleOptionLike = {
	rootGroupId?: string | number;
	tenantId?: string | number;
	selectedGroupId?: string | number;
	data?: {
		id?: number;
		tenantId?: string | number;
		isCustomTenantRole?: boolean;
	};
};

const toNumber = (value: unknown): number | undefined => {
	if (value == null || value === '') {
		return undefined;
	}
	const parsed = Number(value);
	return Number.isNaN(parsed) ? undefined : parsed;
};

export const toCustomTenantRoleOptionKey = (
	roleId: number | string
): string => `${CUSTOM_TENANT_ROLE_KEY_PREFIX}${roleId}`;

export const getTenantRootIdFromGroup = (
	group?: GroupOptionLike
): number | undefined => {
	if (!group) {
		return undefined;
	}
	const data = group.data;
	if (data?.isTenant === true || data?.level === 1) {
		return toNumber(data?.id ?? group.key);
	}
	if (data?.rootGroupId != null && Number(data.rootGroupId) !== 0) {
		return toNumber(data.rootGroupId);
	}
	return toNumber(data?.id ?? group.key);
};

export const customTenantRoleBelongsToSelectedGroups = (
	role: CustomTenantRoleOptionLike,
	groups?: GroupOptionLike[] | null
): boolean => {
	if (!groups?.length) {
		return false;
	}

	const roleTenantId = toNumber(
		role.rootGroupId ?? role.tenantId ?? role.data?.tenantId
	);

	return groups.some((group) => {
		const data = group.data;
		const knownTenantRoot =
			data?.isTenant === true || data?.level === 1
				? toNumber(data?.id ?? group.key)
				: data?.rootGroupId != null && Number(data.rootGroupId) !== 0
				? toNumber(data.rootGroupId)
				: undefined;

		if (
			roleTenantId != null &&
			knownTenantRoot != null &&
			roleTenantId !== knownTenantRoot
		) {
			return false;
		}

		return true;
	});
};
